import { asyncToGenerator as _asyncToGenerator, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import _regeneratorRuntime from 'regenerator-runtime';
import { renderApp } from './renderApp.esm.js';

var renderStatic = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    var _yield$renderApp, redirect, html, data, url;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return renderApp(_extends({}, params, {
              ssg: true
            }));

          case 2:
            _yield$renderApp = _context.sent;
            redirect = _yield$renderApp.redirect;
            html = _yield$renderApp.html;
            data = _yield$renderApp.data;

            if (!redirect) {
              _context.next = 9;
              break;
            }

            url = params.req.url;
            throw new Error("You are not allowed to use redirect in ssg mode, URL: " + url);

          case 9:
            return _context.abrupt("return", {
              html: html,
              data: data
            });

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function renderStatic(_x) {
    return _ref.apply(this, arguments);
  };
}();

export { renderStatic };
//# sourceMappingURL=renderStatic.esm.js.map
